import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Link } from './Link';

type SurfacePadding = 'none' | 'sm' | 'md';

const PADDING_PX: Record<SurfacePadding, number> = { none: 0, sm: 8, md: 12 };

type ClickableSurfaceBaseProps = {
    children: React.ReactNode;
    padding?: SurfacePadding;
    selected?: boolean;
    className?: string;
};

type ClickableSurfaceProps = ClickableSurfaceBaseProps &
    (
        | { to: string; state?: unknown; href?: never; onClick?: never }
        | { href: string; to?: never; onClick?: never }
        | { onClick: (e: React.MouseEvent) => void; to?: never; href?: never }
    );

export function ClickableSurface({
    children,
    padding = 'md',
    selected = false,
    className,
    ...rest
}: ClickableSurfaceProps) {
    return (
        <Surface
            $padding={PADDING_PX[padding]}
            $selected={selected}
            underline={false}
            color="inherit"
            className={className}
            {...rest}
        >
            {children}
        </Surface>
    );
}

const Surface = styled(Link, {
    shouldForwardProp: (prop) => prop !== '$padding' && prop !== '$selected',
})<{ $padding: number; $selected: boolean }>(({ $padding, $selected }) => ({
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: $padding,
    borderRadius: 8,
    fontSize: 'inherit',
    fontWeight: 'inherit',
    backgroundColor: $selected ? Colors.fill : 'transparent',
    transition: 'background-color 0.15s ease',
    '&:hover': {
        backgroundColor: Colors.fill,
        opacity: 1,
    },
}));
